module.exports = __webpack_public_path__ + "static/media/tpn-events-desktop.0bd50bf8.jpg";